<template>
    <!--  小程序运营管理-第三方预约管理-手机号查询 -->
    <div>
        <content-view v-show="$utils.renderWhen(this, 'thirdPartySearch')">
        <div slot="header">
            <a-form :form="form" layout="inline">
                <a-form-item label="预约人电话">
                    <a-input placeholder="请输入" v-decorator="['phone']" @pressEnter="search"></a-input>
                </a-form-item>
                <a-form-item>
                    <a-button @click="search" class="mr8" type="primary">筛选</a-button>
                    <a-button @click="handleReset">重置</a-button>
                </a-form-item>
            </a-form>
        </div>
        <a-card
        :bordered="false"
        >
            <a-table
                :bordered="true"
                :dataSource="dataSource"
                :columns="columns"
                :scroll="{ x: 800 , y: 630}"
                :pagination="pagination"
                @change="changePage"
                :rowKey="(record,index) => index"
            >
                <template slot="shopId" scope="shopId">{{shopId | byShopIdGetShopName}}</template>
                <span slot="state" slot-scope="state">{{['已预约','已取消'][state]}}</span>
                <span slot="action" slot-scope="a,row">
                    <a v-if="getBtnByAuth('modifyReserve') && row.state == 0" class="text-primary" @click="openModal(row)">修改预约信息</a>
                    <a v-else class="text-disabled">修改预约信息</a>
                    <a-popconfirm
                        v-if="getBtnByAuth('cancelReserve') && row.state == 0"
                        title="您确定取消用户当前的预约吗"
                        @confirm="cacelUserReserve(row)"
                        >
                        <a-divider type="vertical" />
                        <a class="text-primary">取消预约</a>
                    </a-popconfirm>
                    <a v-else class="text-disabled"><a-divider type="vertical" />取消预约</a>
                </span>
            </a-table>
        </a-card>
        <a-modal
            title='修改预约信息'
            centered
            :visible="showModal"
            :confirmLoading="confirmLoading"
            @cancel="onCancel"
            @ok="onOK"
            >
            <div>
                <a-form :form="formModal">
                    <a-form-item label="预约日期" :label-col="{ span: 8 }" :wrapper-col="{ span: 16 }">
                        <a-date-picker :disabled-date="disabledDateClose" v-decorator="['reserveDate', {rules: [{ required: true, message: '请选择' }]}]"/>
                    </a-form-item>
                    <a-form-item label="预约人数" :label-col="{ span: 8 }" :wrapper-col="{ span: 16 }">
                        <a-input-number
                        style="width:178px"
                        placeholder="请输入"
                        :precision="0"
                        :min="1"
                        v-decorator="['reserveNum',{rules: [{required: true, message: '请输入游客人数'}]}]"
                        />
                    </a-form-item>
                </a-form>
            </div>
        </a-modal>
        </content-view>
        <router-view></router-view>
    </div>
</template>

<script type="text/javascript">
import { mapGetters } from "vuex";
    const columns = [
        {
            title: "预约人昵称",
            dataIndex: "name"
        },
        {
            title: "预约日期",
            dataIndex: "reserveDate"
        },
        {
            title: "预约人数",
            dataIndex: "reserveNum",
        },
        {
            title: "园区",
            dataIndex: "shopId",
            scopedSlots: { customRender: "shopId"}
        },
        {
            title: "状态",
            dataIndex: "state",
            scopedSlots: { customRender: "state" }
        },
        {
            title: "操作",
            dataIndex: "action",
            scopedSlots: { customRender: "action" }
        }
    ];
    export default {
        name: "thirdPartySearch",
        components: {},
        props: {},
        data() {
            return {
                form: this.$form.createForm(this),
                formModal: this.$form.createForm(this),
                showModal: false,
                dataSource: [],
                columns,
                // 分页
                pagination: {
                    showTotal: total => `共 ${total} 条数据`,
                    showSizeChanger: true,
                    showQuickJumper: true,
                    total: 0,
                    current: 1,
                    pageSize: 20
                },
                changeRow: {},
                confirmLoading: false,
            };
        },
        computed: {
            ...mapGetters(["shopId"])
        },
        methods: {
            handleReset() {
                this.form.resetFields();
                this.getList()
            },
            search() {
                this.pagination.current = 1;
                this.getList();
            },
            changePage(page) {
                this.pagination.pageSize = page.pageSize;
                this.pagination.current = page.current;
                this.getList();
            },
            onTabChange() {
                this.pagination.current = 1;
                this.getList();
            },
            //获取列表
            getList() {
                this.form.validateFields((err, values) => {
                    if (err) return;
                    if(!values.phone) return
                    this.$api.changeCode.queryReserve({
                        body: Object.assign(values, {
                            pageNum: this.pagination.current,
                            pageSize: this.pagination.pageSize
                        })
                    }).then(res => {
                        this.dataSource = res.list;
                        this.pagination.total = res.total;
                    });
                });
            },
            disabledDateClose(current) {
                return current && current < this.$moment().endOf('day').add(-1, 'days');
            },
            openModal(row) {
                this.showModal = true;
                this.changeRow = row;
            },
            onCancel() {
                this.showModal = false;
                this.formModal.resetFields();
            },
            cacelUserReserve(row) {
                this.$api.changeCode.cacelUserReserve({
                    body: {
                        id: row.id
                    }
                }).then(res => {
                    this.$message.success('操作成功');
                    this.search();
                });
            },
            onOK() {
                this.formModal.validateFields((err, values) => {
                    if (err) return;
                    this.confirmLoading = true;
                    this.$api.changeCode.userReserve({
                        body: {
                            ...this.changeRow,
                            reserveDate: values.reserveDate.format('YYYY-MM-DD'),
                            reserveNum: values.reserveNum
                        }
                    }).then(res => {
                        this.search();
                        this.onCancel();
                        this.$message.success('操作成功');
                        this.confirmLoading = false;
                    }).catch(err => {
                        this.confirmLoading = false;
                    })
                });
            }
        },
        mounted() {
            // this.getList();
        }
    };
</script>